module.exports = __webpack_public_path__ + "24bd1bc91f1e5aba4ccf174221d353b2.gif";